import MainPicture from "../../../common/assets/images/General/ACM_SOZH_logoWithTitle.svg";
import MainPictureTwo from "../../../common/assets/images/General/ACM_Montronix_logoWithTitle.svg";
import MainMini from "../../../common/assets/images/General/ACM_SOZH_mini.svg";
import SOZH from "../../../common/assets/images/General/SOZH_Left.jpg";
import SOZH1 from "../../../common/assets/images/General/Montronix-Wifi.png";
import SOZH2 from "../../../common/assets/images/General/Montronix-PulseNG.png";
import SOZH3 from "../../../common/assets/images/General/Montronix-spectrang.png";

import {Link} from "react-router-dom";
import {setGuideMode} from "../../../common/UI/GuideButtons/logic/GuideLogic";
import {useEffect, useState} from "react";

import "../styles/MainGeneralPage.css";
import {
    titleName,
    onMouseLeaveOne,
    onMouseEnterOne,
    onMouseEnterTwo,
    onMouseLeaveTwo
} from "../../../common/function";

export interface IForMainModal {
    image: string;
    haveBanner: boolean;
    title: string;
    text: string;
    href: string;
}

export const MainPageGenral = () => {
    titleName("Выбор презентации");
    const [, setSwitcher] = useState<boolean>(false);
    useEffect(() => {
        setGuideMode(false);
        setTimeout(() => {
            setSwitcher(true);
        }, 5000);
    }, []);
    return (
        <>
            <div className="mainFlexGeneral">
                <div id="mainFlexTitlePhone" className="mainFlexTitlePhone">
                    Выберите презентацию для продолжения
                </div>
                <div id="mainFlexOne" className="mainFlexOne" onMouseEnter={onMouseEnterOne}
                     onMouseLeave={onMouseLeaveOne}>
                    <Link to="/pwa">
                        <img src={MainPicture} alt="" className="logoGeneral"/>
                        <div className="hideGeneral imageCeprGenral">
                            <img src={SOZH} alt="" className="imageGeneralCeprBlock"/>
                        </div>
                    </Link>
                </div>
                <div id="mainFlexTwo" className="mainFlexTwo" onMouseEnter={onMouseEnterTwo}
                     onMouseLeave={onMouseLeaveTwo}>
                    <Link to="/montronix">
                        <img src={MainPictureTwo} alt="" className="logoGeneral"/>
                        <div className="hideGeneral imageMontronix-block">
                            <div className="imageMontronix-block__up">
                                <img
                                    src={SOZH1}
                                    alt=""
                                    className="imageMontronix-blockGeneralTitle__picture imageMontronix-block__picture"
                                />
                                <img
                                    src={SOZH2}
                                    alt=""
                                    className="imageMontronix-blockGeneralTitle__picture imageMontronix-block__picture"
                                />
                            </div>
                            <img
                                src={SOZH3}
                                alt=""
                                className="imageMontronix-blockGeneralTitle__picture imageMontronix-block__picture"
                            />
                        </div>
                    </Link>
                </div>
                <div className="LeftImageGeneral">
                  <img src={MainMini} alt="" className="imageLeftBlock"/>
                </div>
            </div>
        </>
    );
};
